// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"0997304a","453":"4bb60fdf","542":"9230e956","555":"902431ce","577":"2d665cfd","615":"e0e5252b"}[chunkId] + ".chunk.js";
};